import { PENDING_SUBMISSION_STATUS } from '../constants/instituteSubmission.constants';
import type { InstituteSubmissionDetail } from '../types/instituteSubmission.types';
import { InstituteSubmissionReviewActions } from './InstituteSubmissionReviewActions';
import { InstituteSubmissionReviewSummary } from './InstituteSubmissionReviewSummary';

interface InstituteSubmissionReviewPanelProps {
  submission: InstituteSubmissionDetail;
}

export function InstituteSubmissionReviewPanel({
  submission,
}: InstituteSubmissionReviewPanelProps) {
  if (submission.status === PENDING_SUBMISSION_STATUS) {
    return <InstituteSubmissionReviewActions submission={submission} />;
  }

  return (
    <InstituteSubmissionReviewSummary
      status={submission.status}
      reviewedByName={submission.reviewedByName}
      reviewedAt={submission.reviewedAt}
      reviewerComment={submission.reviewerComment}
    />
  );
}
